import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

type ToggleButtonStyledProps = {
  option: number;
  index: number;
  optionslength: number;
  spacing: number;
  height: string;
  padding: string;
  selectedButtonColors?: { backgroundColor?: string, textColor?: string };
};

export const ToggleButtonOption = styled(Button)<ToggleButtonStyledProps>(
  ({ theme, option, index, optionslength, spacing, height, padding, selectedButtonColors = {backgroundColor: theme.colors.neutral.softGray, textColor: theme.colors.neutral.black} }) => ({
    marginRight: index < optionslength - 1 ? spacing : 0,
    borderRadius: "8px",
    height: height,
    padding: padding,
    backgroundColor:
      index === option ? selectedButtonColors.backgroundColor : "transparent",
    color:
      index === option
        ? selectedButtonColors.textColor
        : theme.colors.neutral.darkGray,
    "@media (hover: none)": {
      "&:hover": {
        backgroundColor: "initial",
      },
    },
  })
);
